import React from 'react';
import './index.scss';
import Logo from '../../assets/images/Logo/Logomark White.png';
import Pegadaian from '../../assets/img/LOGO PEGADAIAN.png';
import Peersona from '../../assets/img/peersona.png';
import { AiFillInstagram, AiFillLinkedin } from 'react-icons/ai';

function Footer() {
    return (
        <footer>
            <div className="p-3 container">
                <div className="row">
                    <div className="col-lg-9 col-md-8 col-sm-7 col-12">
                        <img 
                            src={Logo} 
                            alt="logo"
                            className="img-footer"
                        />
                        <h1 className="impulse"> IMPULSE</h1>
                        <p className="my-2 white">Impulse 2021: Innovate, Engage, Collaborate</p>
                        <a href="https://instagram.com/impulseitb/" target="_blank" className="white"><AiFillInstagram className="icon white ml-n1"/>impulseitb</a><br /><br />
                        <a className="pegadaian" href="/sponsor"><img src={Pegadaian} alt="logo pegadaian"/></a>
                        <a className="peersona" href="/sponsor2"><img src={Peersona} alt="logo peersona"/></a>
                    </div>
                    
                    <div className="col-lg-3 col-md-4 col-sm-5 col-12 text-left text-sm-right">
                        <h5 className="events mt-sm-3 mt-5">Events</h5><hr className="hr-footer mr-sm-0 ml-sm-4 ml-0 mr-5"/>
                        <p><a className="white" href="/event/competitionuniv">Innovation Competition</a></p>
                        <p><a className="white" href="/event/competitionsma">Paper Competition</a></p>
                        <p><a className="white" href="/event/seminar">Grand Seminar</a></p>
                        <p><a className="white" href="/event/Workshop">Workshop</a></p>
                    </div> 
                    
                </div>
            </div>
            <div className="text-center">
                <small>&copy; 2021 IMPULSE</small>    
            </div>
        </footer>
    );
}

export default Footer;